module.exports = __webpack_public_path__ + "img/DSC_0017.7c994c61.jpg";